import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext';
import { getLocalizedCaseDisplay } from '../../data/caseProfiles';
import { getDoctorEmojiForGender } from '../../utils/userAvatar';
import './Chat.css';

const ChatMessage = ({ message, patientName }) => {
  const { language, t } = useLanguage();
  const { user } = useAuth();
  const doctorEmoji = getDoctorEmojiForGender(user?.gender);
  const getAvatar = () => {
    switch (message.sender) {
      case 'user':
        return <div className="avatar-user">{doctorEmoji}</div>;
      case 'ai':
        return <div className="avatar-patient">👤</div>;
      default:
        return <div className="avatar-system">⚙️</div>;
    }
  };

  const getSenderName = () => {
    switch (message.sender) {
      case 'user':
        return t('youStudent');
      case 'ai':
        return patientName;
      default:
        return t('system');
    }
  };

  const normalizedText = typeof message.text === 'string'
    ? message.text.replace(/\\n/g, '\n')
    : message.text;

  const renderChart = () => {
    const chart = message.chart || {};
    const displayCase = chart.caseId
      ? getLocalizedCaseDisplay({
        id: chart.caseId,
        name: chart.patient,
        age: chart.age,
        chiefComplaint: chart.chiefComplaint,
        gender: chart.demographics?.sex,
        setting: chart.demographics?.setting
      }, language)
      : null;
    const demographics = {
      ...chart.demographics,
      sex: displayCase?.gender || chart.demographics?.sex,
      setting: displayCase?.setting || chart.demographics?.setting
    };
    return (
      <div className="patient-chart-card">
        <div className="chart-card-header">
          <span>{t('medicalCaseAnketa')}</span>
          <strong>{displayCase?.name || chart.patient}</strong>
        </div>
        <div className="chart-card-grid">
          <div>
            <span>{t('age')}</span>
            <strong>{displayCase?.age || chart.age || chart.demographics?.age || '—'}</strong>
          </div>
          <div>
            <span>{t('gender')}</span>
            <strong>{demographics.sex || '—'}</strong>
          </div>
          <div>
            <span>{t('setting')}</span>
            <strong>{demographics.setting || t('patientInterview')}</strong>
          </div>
        </div>
        <p className="chart-complaint">{displayCase?.chiefComplaint || chart.chiefComplaint}</p>
        {(displayCase?.triage || chart.triage) && (
          <p className="chart-triage">{displayCase?.triage || chart.triage}</p>
        )}
      </div>
    );
  };

  return (
    <div className={`chat-message ${message.sender}`}>
      <div className="message-avatar">
        {getAvatar()}
      </div>
      <div className="message-content">
        <div className="message-header">
          <span className="sender-name">{getSenderName()}</span>
          <span className="message-time">{message.timestamp}</span>
        </div>
        <div className="message-text">
          {message.type === 'chart' ? renderChart() : normalizedText}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
